// extracted by mini-css-extract-plugin
export default {"main":"Language_main__9S+kE","title":"Language_title__TBkf-","languages":"Language_languages__udeM4","lang":"Language_lang__pPnWl","active":"Language_active__HM7OJ"};